// "Medium Rectangle (300 x 250 px)" → "Medium Rectangle".
export const formatName = (format) => (format?.name || '').split(' (')[0];
